import {Collapse, Grid} from "@mui/material";
import {memo, useCallback, useState} from "react";
import MhdInput from "../../atomicComponents/MhdInput";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";

import MhdMarkerSymbolChoices from "../../atomicComponents/MhdMarkerSymbolChoices";
import MhdLineWidthChoices from "../../atomicComponents/MhdLineWidthChoices";
import MhdLineStyleChoices from "../../atomicComponents/MhdLineStyleChoices";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdSolidColorWidget from "../../atomicComponents/MhdSolidColorWidget";
import WidgetDivider from "../../atomicComponents/WidgetDivider";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";

const PointWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customizeStyle, setCustomizeStyle] = useState(false)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="QUERY POSITION"
            value={data.query_point}
            onChange={useCallback((v) => setAndUpdate('query_point', v, setter, update), [])}
        >
          <Collapse in={data.query_point} >
            <Grid container spacing={1} pt={"2px"} pb={1}>
              <Grid item xs={6}>
                <MhdInput
                  label={'Longitude'}
                  value={data.point_xvalue}
                  override={mods.point_xvalue}
                  warning={warn.point_xvalue}
                  error={errs.point_xvalue}
                  onChange={useCallback((v) => validateAndUpdate("point_xvalue", v, setter, update), [])}
                  units={'°'}
                />
              </Grid>
              <Grid item xs={6}>
                <MhdInput
                  label={'Latitude'}
                  value={data.point_yvalue}
                  override={mods.point_yvalue}
                  warning={warn.point_yvalue}
                  error={errs.point_yvalue}
                  onChange={useCallback((v) => validateAndUpdate("point_yvalue", v, setter, update), [])}
                  units={'°'}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>

      <Grid item xs={12} mb={data.query_point ? 0 : -1}>
        <Collapse in={data.query_point}>
          <MhdWidgetDivider
              label="CUSTOMIZE STYLE"
              value={customizeStyle}
              onChange={setCustomizeStyle}
          >
            <Collapse in={customizeStyle} >
              <Grid container spacing={1} pt={"2px"}>
                <Grid item xs={3}>
                  <MhdSolidColorWidget
                    label="Line Color"
                    value={data.color}
                    onChange={useCallback((v) => setAndUpdate("color", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={3}>
                  <MhdMarkerSymbolChoices
                    label="Symbols"
                    value={data.marker_symbol}
                    onChange={useCallback((v) => setAndUpdate("marker_symbol", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={3}>
                  <MhdLineWidthChoices
                    label="Line Width"
                    value={data.line_width}
                    onChange={useCallback((v) => setAndUpdate("line_width", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={3}>
                  <MhdLineStyleChoices
                    label="Line Style"
                    value={data.line_style}
                    onChange={useCallback((v) => setAndUpdate("line_style", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={4}>
                  <WidgetSwitch
                    label="Show Point"
                    value={data.show_point}
                    onChange={useCallback((v) => setAndUpdate("show_point", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={4}>
                  <WidgetSwitch
                    label="Show Lines"
                    value={data.show_lines}
                    onChange={useCallback((v) => setAndUpdate("show_lines", v, setter, update), [])}
                  />
                </Grid>
                <Grid item xs={4}>
                  <WidgetSwitch
                    label="Show Text"
                    value={data.show_text}
                    onChange={useCallback((v) => setAndUpdate("show_text", v, setter, update), [])}
                  />
                </Grid>
              </Grid>
            </Collapse>
          </MhdWidgetDivider>
        </Collapse>
      </Grid>
    </Grid>
  );
}

export default memo(PointWidget);